var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "w-full flex pt-2 flex-col" }, [
    _c(
      "div",
      { staticClass: "w-full" },
      [
        _c("deal-dropdown-field", {
          attrs: {
            deals: _vm.deals,
            loanIds: _vm.loanIds,
            placeholder: "Select Deal",
          },
          model: {
            value: _vm.dealId,
            callback: function ($$v) {
              _vm.dealId = $$v
            },
            expression: "dealId",
          },
        }),
        _vm._v(" "),
        _c(
          "field",
          { staticClass: "mb-2", attrs: { label: "Reason" } },
          [
            _c("textarea-field", {
              model: {
                value: _vm.description,
                callback: function ($$v) {
                  _vm.description = $$v
                },
                expression: "description",
              },
            }),
          ],
          1
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "flex flex-row-reverse pt-4" },
      [
        _c(
          "btn",
          {
            on: {
              click: function ($event) {
                return _vm.closeProp()
              },
            },
          },
          [_vm._v("Allocate")]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }